import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import LoadCSSforfirstTime from "../../../../../../CloudStorage/LoadCSSforfirstTime";
import { scrollToTop } from "../../../../../../CloudStorage/CommonFunction";
import MergersAcquisitionDetails from "../../../../FindWork/SearchMergersAcquisitions/AllBuyProducts/MergersAcquisitionDetails";
import CloudStorage from "../../../../../../CloudStorage/CloudStorage";
import { TabContent, TabPane } from "reactstrap";
import { getMergersOrderList } from "../../../../../../redux/mergers/action";
import useChatNavigation from "../../../../../Common/useChatNavigation";
import PostNotFound from "../../../../../CustomComponents/AllLoader/PostNotFound";
import ProfileImageWithFallback from "../../../../../../common/ProfileImageWithFallback";

export default function MergersAcquisitions() {
  const laung = localStorage.getItem("laung");
  const path = "Assets/scss/myorders.module.scss";
  const { letChat } = useChatNavigation();

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const [lan, setLan] = useState(laung ?? "en");
  const dispatch = useDispatch();

  const [modalOpen, setModalOpen] = useState(false);
  const [bxpData, setbxpData] = useState("");
  const [activeTab, setActiveTab] = useState("BXPDetails");

  const closeModal = () => {
    setModalOpen(false);
  };

  const modalStyle = {
    right: modalOpen ? "0" : "-50%",
  };
  useEffect(() => {
    scrollToTop();
  }, [activeTab]);
  const mergerlist = useSelector(({ mergers: { mergersorderlist } }) => mergersorderlist);

  useEffect(() => {
    dispatch(getMergersOrderList(1));
  }, []);

  return (
    <>
      {Array.isArray(mergerlist) && mergerlist.length > 0 ?
        (
          <>
            <div className="posted-project umbrellaproject-sec pending-req">
              <div className="row packaged-row merger-packaged merge-packaged-img-sec">
                {mergerlist.map((item, index) => (

                  <div className="col-md-4" key={index}>
                    <div className="packaged-img">
                      <ProfileImageWithFallback url={item?.logo} style={{ objectFit: 'contain', width:'200px', borderRadius: 0 }} />
                      <h3>{item?.company_name}</h3>
                      <h6>{item?.industry_title}</h6>
                      <h6>{item?.website_link}</h6>
                      <p>
                        {item?.city} - {item?.pincode}
                      </p>
                      <button
                        className="buttons border-button"
                        onClick={() => {
                          setModalOpen(true);
                          setbxpData(item);
                        }}
                      >
                        View more
                      </button>
                      {/* <button onClick={() => letChat(item)} className ="buttons border-button">
                  <img src={`${CloudStorage.cloudurl}/Assets/Images/common/message-color.svg`} alt="" />
                </button> */}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        ) : (
          <PostNotFound title="No Post Found" height={500} />
        )}


      {/* Modal */}
      {modalOpen && (
        <div
          isOpen={modalOpen}
          keyboard={false}
          className="add-education-modal add-bxp-modal add-overlay-modal-width"
          style={modalStyle}
        >


          <div className={`modal-overlay-sec   ${modalOpen ? 'active' : ''}`}></div>
          <div className="modal-width">
            <div className="modal-head">
              <h3>Information</h3>
              <button onClick={closeModal} className="btn close-modal-btn">
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/close-icon.svg`}
                  alt="Close"
                />
              </button>
            </div>

            <div className="tab-bxp">
              <TabContent activeTab={activeTab}>
                <TabPane tabId="BXPDetails">
                  <MergersAcquisitionDetails
                    showbutton={false}
                    bxpData={bxpData}
                    setActiveTab={setActiveTab}
                    setModalOpen={setModalOpen}
                    needtohitapi={false}
                  />
                </TabPane>
              </TabContent>
            </div>
          </div>
        </div>
      )}
    </>

  );
}
